import { Stack, Typography } from "@mui/material";
import { UnstyledButton } from "Components/Shared/Buttons/UnstyledButton";
import type { ElementType } from "react";

type Props = {
  Icon: ElementType;
  label: string;
  onClick?: () => void;
};

// Icon-above-label action button used in actions row (transaction detail, QR actions).
export const IconActionButton = ({ Icon, label, onClick }: Props) => (
  <UnstyledButton
    aria-label={label}
    tabIndex={0}
    onClick={onClick}
    sx={{ justifyContent: "center", flexBasis: "33%" }}
  >
    <Stack gap={1.5} component="span" alignItems="center">
      <Icon sx={{ fontSize: [32, 40], color: "primary.main" }} />
      <Typography
        variant="body1"
        sx={{ color: "primary.main", fontWeight: 400, fontSize: [14, 16] }}
      >
        {label}
      </Typography>
    </Stack>
  </UnstyledButton>
);
